const IsSuscribed = (value) => {
  if (value)
    return (value.indexOf('SUBSCRIBED') > -1)
  else
    return false;
}

const IsDisallow = (value) => {
  if (value)
    return (value.indexOf('DISALLOW') > -1)
  else
    return false;
}

export default { IsSuscribed, IsDisallow }




// WEBPACK FOOTER //
// ./Statics/scripts/paywall/helpers/metering.js